import { ObjetivoService } from '../../services/objetivo.service';
import { ProyectoService} from '../../services/proyecto.service';
import { ProcesoService} from './../../services/proceso.service';
import { EstrategiaObjetivoService} from './../../services/estrategia-objetivo.service';
import { LineaAccionService} from './../../services/linea-accion.service';
import { PlanAccionService} from './../../services/plan.accion.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject, map } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { IndicadoresService } from '../../services/indicadores.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EstrategiasService } from '../../services/estrategias.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { PlanesInstitucionalesAnualesService } from 'src/app/modulos/catalogos-admin/services/planes-institucionales-anuales.service';

@Component({
  selector: 'app-indicadores',
  templateUrl: './indicadores.component.html',
  //styleUrls: ['./indicadores.component.css']
})
export class IndicadoresComponent  {
  breadCrumbItems = [{label: 'Formulación Planes'}, {label: 'Elementos'}, {label: 'Indicadores', active: true}];
 
  public formApp: UntypedFormGroup;
  public formIndicadoresObjetivos: UntypedFormGroup;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataIndicadores: any[] = [];
  public dataObjetivo: any[] = [];
  public dataProyectos: any[] = [];
  public dataProcesos: any[] = [];
  public dataObjetivoIndicadores: any = [];
  public dataProyectoIndicadores: any = [];
  public dataEstrategiasObjetivos: any = [];
  public dataLineasAccionIndicadores: any = [];
  public dataPlanAccionIndicadores: any = [];
  public dataProcesosIndicadores: any = [];
  public dataLineaAccion: any = [];
  public dataEstrategias: any = [];
  private idDeleteRegister: number = 0;
  public idSprAmbiente:number;
  public selectItems: any[] = [];
  public pestanias: any[] = [];
  public nameModal: string = 'modalNewEdit'
  public dataProcess:any[];
  public showObjetivos:string ='';
  public showProyectos:string ='';
  public showProcesos:string ='';

  public activeObjetivos:string = '';
  public activeProyectos:string = '';

  public proceso:string = '';
  public lineAction:string = '';
  public planAccion:string = '';
  public proyecto:string = '';
  public objetivo:string = '';

  public idSprNivelN5: number = 0;
  public nivelSelect!: number;

  public planAnioSeleccionadoRedux:any = null;
  //Array que almacena los ids de los objetivos del plan anual seleccionado 
  public dataObjetivosPorAnio:any = null;



constructor(
    private fb: FormBuilder,
    private objetivos:ObjetivoService,
    private proyectos:ProyectoService,
    private procesos:ProcesoService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private indicadoreServices:IndicadoresService,
    private ruta: Router, private location: Location,
    private estrategiaObjectService: EstrategiaObjetivoService,
    private estrategiasService:EstrategiasService,
    private lineaAccionService:LineaAccionService,
    private planAccionService:PlanAccionService,
    public store: Store<AppState>,
    private planInstitucionalAnualService: PlanesInstitucionalesAnualesService,
    
){
  this.idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5; //validacion (de nivel n5)  
  this.buffer = localStorage.getItem('currentUser');
  this.currentUser = JSON.parse(this.buffer);
  
  this.nivelSelect = this.currentUser.idSprNivel
};


openObjetivos(){
   this.objetivo= 'objetivo';
   this.lineAction ='-';
   this.planAccion ='-';
   this.proyecto ='-';
   this.proceso ='-';
}
openLineasAccion(){
  this.lineAction='lineaAccion'
  this.objetivo= '-';
  this.planAccion ='-';
  this.proyecto ='-';
  this.proceso ='-';
}
openPlanesAccion(){
  this.planAccion='planAccion'
  this.objetivo= '-';
  this.lineAction ='-';
  this.proyecto ='-';
  this.proceso ='-';
}
openProyectos(){
  this.objetivo= '-';
   this.lineAction ='-';
   this.planAccion ='-';
   this.proceso ='-';
  this.proyecto ='proyecto';
}                                 

openProcesos(){
  this.proceso ='proceso';
  this.objetivo= '-';
  this.lineAction ='-';
  this.planAccion ='-';
  this.proyecto ='-';
}


ngOnInit(): void {
  this.openObjetivos();

  this.store.select('globalApp').subscribe(response=>{
    this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
  })

  this.planInstitucionalAnualService.list(`?idSprAnio=${this.planAnioSeleccionadoRedux.idSprAnio}`).pipe(      
    map(response=>response.map(({idSprObjetivo})=>{      
      return idSprObjetivo
    })))
    .subscribe(response=>{
    this.dataObjetivosPorAnio = response      
  }) 
}


}
